





























import { defineComponent } from '@nuxtjs/composition-api'

type CardItemType = 'image-text' | 'icon-text'

const sizes = {
  'image-text': [375, 375],
  'icon-text': [48, 48],
}

const multipliers = {
  'image-text': 1,
  'icon-text': 4,
}

export default defineComponent({
  name: 'RgsCardItem',
  props: {
    type: {
      type: String as PropType<CardItemType>,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    imageDesktop: {
      type: String,
      default: '',
    },
    svgIcon: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      sizes,
      multipliers,
    }
  },
})
